import { render, staticRenderFns } from "./modalServicosAgenda.vue?vue&type=template&id=05251eb2"
import script from "./modalServicosAgenda.vue?vue&type=script&lang=js"
export * from "./modalServicosAgenda.vue?vue&type=script&lang=js"
import style0 from "./modalServicosAgenda.vue?vue&type=style&index=0&id=05251eb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports